
  import PrintFriendlyResults from "@/components/PrintFriendlyResults.vue"; // @ is an alias to /src

  export default {
    name: "Print",
    components: {
      PrintFriendlyResults
    }
  }
